import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as API from '../../api/routes';
import {
  DEPARTMENT_GET_LIST,
  POSITION_GET_LIST,
} from '../actions';

import {
  departmentGetListSuccessed,
  departmentGetListFailed,
  positionGetListSuccessed,
  positionGetListFailed,
} from './actions';

function* departmentGetList({ callback }) {
  try {
    const res = yield call(API.departmentGetList);
    yield put(departmentGetListSuccessed(res.result));
    yield call(callback?.(res.result));
  } catch (error) {
    yield put(departmentGetListFailed(error.error_message));
  }
}

function* positionGetList() {
  try {
    const res = yield call(API.positionGetList);
    yield put(positionGetListSuccessed(res.result));
  } catch (error) {
    yield put(positionGetListFailed(error.error_message));
  }
}

export function* watchWorkers() {
  yield takeEvery(DEPARTMENT_GET_LIST, departmentGetList);
  yield takeEvery(POSITION_GET_LIST, positionGetList);
}

export default function* rootSaga() {
  yield all([
    fork(watchWorkers)
  ]);
}